import Immutable from 'immutable';
import reducerCreator from '../../tools/reducer-creator';
import * as types from '../../actions/password-recovery/types';

const initialState = Immutable.fromJS({
  isLoading: true
});

export default reducerCreator(initialState, {
  [types.PASSWORD_RECOVERY_SET_RESET_PASSWORD_LOADING]: (state, { isLoading }) => state.set('isLoading', isLoading),
  [types.PASSWORD_RECOVERY_RESET_RESET_PASSWORD_STATE]: () => initialState,
  [types.PASSWORD_RECOVERY_SET_PASSWORD_SUCCEFULLY_CHANGED]: (state, { passwordSuccessfullyChanged }) => state.set('passwordSuccessfullyChanged', passwordSuccessfullyChanged),
  [types.PASSWORD_RECOVERY_SET_CODE_IS_EXPIRED_OR_USED]: (state, { codeIsExpiredOrUsed }) => state.set('codeIsExpiredOrUsed', codeIsExpiredOrUsed),
  [types.PASSWORD_RECOVERY_SET_CODE_IS_NOT_FOUND]: (state, { codeIsNotFound }) => state.set('codeIsNotFound', codeIsNotFound)
});



// WEBPACK FOOTER //
// ./src/reducers/password-recovery/reset-password.js